let finalTotalPrice = 0;
let finalcomparePrice = 0;

function addToBundle(title, imageUrl, price, button, id) {
  const bundleItems = document.querySelectorAll(".bundle-2 li");
  let itemReplaced = false;

  bundleItems.forEach((item) => {
    if (!itemReplaced && item.innerHTML.trim() === "") {
      item.innerHTML = `
              <div class="img-product">
                  <img class="img-contain" src="${imageUrl}" alt="${title}">
              </div>
              <button class="remove-btn" onclick="removeFromBundle(this)">&#10005;</button>`;
      item.classList.add("no-after");
      item.setAttribute("data-title", title);
      item.setAttribute("data-id", id);

      const alhSavingElement = document.querySelector(".alh-saving");
      if (alhSavingElement) {
        alhSavingElement.innerHTML = "";
      }

      const priceElement =
        button.parentElement.parentElement.querySelector(".shop-btn-price h3");

      const originalPriceText = priceElement.textContent.trim();
      const originalPrice = parseFloat(
        originalPriceText.replace(/[^\d\.]/g, "")
      );

      const alhTotalPrice =
        Math.round(finalTotalPrice) + Math.round(originalPrice);
      if (alhTotalPrice > 0) {
        document.querySelector(
          ".alh-price"
        ).innerHTML = `$${alhTotalPrice.toFixed(2)}`;

        // document.querySelector(".alh-compare").innerHTML = `$${price}`;
      } else {
        document.querySelector(".alh-price").innerHTML = `$0`;
      }

      finalTotalPrice = alhTotalPrice;

      itemReplaced = true;

      checkBundleItems();
    }
  });

  if (!itemReplaced) {
    console.log("No available space in bundle-2.");
    const addToSetButtons = document.querySelectorAll(".shop-now-btn");
    addToSetButtons.forEach((btn) => {
      btn.setAttribute("disabled", "");
    });
  } else {
    const quantitySpan = button.previousElementSibling;
    let quantity = parseInt(quantitySpan.textContent);
    quantitySpan.textContent = quantity + 1;
  }
}

function toggleQuantityControl(button, title, imageUrl, price, id) {
  // Hide the controls div containing the "Add To Set" button
  button.parentElement.style.display = "none";
  // Show the quantity control section
  const quantityControl = button.parentElement.nextElementSibling;
  quantityControl.style.display = "flex";

  addToBundle(title, imageUrl, price, button, id);
}

function removeFromBundle(button) {
  const item = button.closest("li");
  const title = item.getAttribute("data-title");

  const productCards = document.querySelectorAll(".proudct-card");
  productCards.forEach((card) => {
    const productTitle = card.querySelector(".product-title").textContent;
    if (productTitle === title) {
      const decreaseButton = card.querySelector(
        ".quantity-control button:first-child"
      );

      const priceElement = card.querySelector(".shop-btn-price h3");
      const priceText = priceElement ? priceElement.textContent.trim() : "";
      const price = Math.floor(parseFloat(priceText.replace(/[^\d\.]/g, "")));

      decreaseQuantity(decreaseButton, title, price);
      return;
    }
  });
}

function increaseQuantity(button, title, imageUrl, price, id) {
  addToBundle(title, imageUrl, price, button, id);
}

function decreaseQuantity(button, title, price) {
  // Decrease the quantity by 1, but not below 1
  const quantitySpan = button.nextElementSibling;
  let quantity = parseInt(quantitySpan.textContent);

  const bundleItems = document.querySelectorAll(".bundle-2 li");
  const bundleList = document.querySelector(".bundle-2");

  if (quantity > 1) {
    quantitySpan.textContent = quantity - 1;

    for (const item of bundleItems) {
      if (item.getAttribute("data-title") === title) {
        item.innerHTML = "";
        item.classList.remove("no-after");
        item.removeAttribute("data-title");
        bundleList.appendChild(item);

        const priceElement =
          button.parentElement.parentElement.querySelector(
            ".shop-btn-price h3"
          );

        const originalPriceText = priceElement.textContent.trim();
        const originalPrice = parseFloat(
          originalPriceText.replace(/[^\d\.]/g, "")
        );

        const alhTotalPrice =
          Math.round(finalTotalPrice) - Math.round(originalPrice);
        document.querySelector(
          ".alh-price"
        ).innerHTML = `$${alhTotalPrice.toFixed(2)}`;
        finalTotalPrice = alhTotalPrice;

        const addToSetButtons = document.querySelectorAll(".shop-now-btn");
        addToSetButtons.forEach((btn) => {
          btn.removeAttribute("disabled", "");
        });

        checkBundleItems();

        break;
      }
    }
  } else {
    button.parentElement.style.display = "none";
    // hide the quantity control section
    const quantityControl = button.parentElement.previousElementSibling;
    quantityControl.style.display = "flex";

    for (const item of bundleItems) {
      if (item.getAttribute("data-title") === title) {
        item.innerHTML = "";
        item.classList.remove("no-after");
        item.removeAttribute("data-title");
        bundleList.appendChild(item);

        const priceElement =
          button.parentElement.parentElement.querySelector(
            ".shop-btn-price h3"
          );

        const originalPriceText = priceElement.textContent.trim();
        const originalPrice = parseFloat(
          originalPriceText.replace(/[^\d\.]/g, "")
        );

        const alhTotalPrice =
          Math.round(finalTotalPrice) - Math.round(originalPrice);
        if (
          alhTotalPrice > 0.0 &&
          alhTotalPrice !== 0.05 &&
          alhTotalPrice !== 0.5
        ) {
          document.querySelector(
            ".alh-price"
          ).innerHTML = `$${alhTotalPrice.toFixed(2)}`;
        } else {
          document.querySelector(".alh-price").innerHTML = `$0`;
        }
        finalTotalPrice = alhTotalPrice;

        const addToSetButtons = document.querySelectorAll(".shop-now-btn");
        addToSetButtons.forEach((btn) => {
          btn.removeAttribute("disabled", "");
        });

        checkBundleItems();

        break;
      }
    }
  }
}

function applyDiscountToProductCards(saving) {
  // Loop through each product card and apply the discount
  const productCards = document.querySelectorAll(".proudct-card");
  productCards.forEach((card) => {
    const priceElement = card.querySelector(".shop-btn-price h3");
    const proPrice = card.querySelector(".alh-pro__price");

    if (priceElement) {
      const originalPriceText = proPrice.textContent.trim();
      const originalPrice = parseFloat(
        originalPriceText.replace(/[^\d\.]/g, "")
      );
      // Calculate the new price after discount
      const discountedPrice =
        Math.round(originalPrice) - Math.round(originalPrice) * (saving / 100);

      // Update the price display in the product card
      priceElement.innerHTML = `
        ${Math.round(discountedPrice).toFixed(
          2
        )} <span class="select-compare">${originalPriceText}</span>`;
    }
  });
}

applyDiscountToProductCards(15);

function toggleDropdown() {
  const bundleList = document.getElementById("bundle-list");
  bundleList.style.display =
    bundleList.style.display === "none" || bundleList.style.display === ""
      ? "block"
      : "none";

  const dropdownIcon = document.getElementById("dropdownIcon");
  dropdownIcon.classList.toggle("rotate-90");
}

function selectOption(setName, savingText, saving, number) {
  finalTotalPrice = 0;
  finalcomparePrice = 0;

  const alhSavingElement = document.querySelector(".alh-saving");
  if (alhSavingElement) {
    alhSavingElement.innerHTML = "";
  }

  const addToSetButtons = document.querySelectorAll(".shop-now-btn");
  addToSetButtons.forEach((btn) => {
    btn.removeAttribute("disabled", "");
  });

  document.querySelector(
    ".select-active"
  ).innerHTML = `${setName} <span class="savings alh-saving">${savingText}</span> <span class="price alh-price"></span><span class="select-compare alh-compare"></span>`;
  // document.querySelector(
  //   ".select-active"
  // ).innerHTML = `${setName} <span class="total-price"><span class="price">${price}</span> ${
  //   comparePrice ? `<span class="select-compare">${comparePrice}</span>` : ""
  // }</span>`;

  // Set all quantities to 0 in each product card
  const productCards = document.querySelectorAll(".proudct-card");
  productCards.forEach((card) => {
    const quantitySpan = card.querySelector(".quantity-control .quantity");
    if (quantitySpan) {
      quantitySpan.textContent = "1"; // Set quantity to 0
    }

    // Hide the quantity control section and show the "Add To Set" button
    const quantityControl = card.querySelector(".quantity-control");
    const addToSetButton = card.querySelector(".shop-now-btn");
    if (quantityControl && addToSetButton) {
      quantityControl.style.display = "none"; // Hide quantity controls
      addToSetButton.parentElement.style.display = "block"; // Show "Add To Set" button
    }
  });

  const bundle2 = document.querySelector(".bundle-2");
  bundle2.innerHTML = "";
  for (let i = 0; i < number; i++) {
    const li = document.createElement("li");
    bundle2.appendChild(li);
  }
  if (window.innerWidth > 767) {
    const bundleLeft = document.querySelector(".bundle-left");
    bundleLeft.style.height = "920px";
  }

  toggleDropdown();

  applyDiscountToProductCards(saving);

  checkBundleItems();
}

// Close dropdown if clicked outside
document.addEventListener("click", function (e) {
  const bundleSelect = document.querySelector(".bundle-select");
  if (!bundleSelect.contains(e.target)) {
    document.getElementById("bundle-list").style.display = "none";
  }
});

const addToCartButton = document.querySelector(".alh-action-button");

function checkBundleItems() {
  const bundleItems = document.querySelectorAll(".bundle-2 li");
  let allItemsFilled = true;

  bundleItems.forEach((item) => {
    if (item.innerHTML.trim() === "") {
      allItemsFilled = false;
    }
  });

  // Enable or disable the Add to Cart button based on whether all items are filled
  if (allItemsFilled) {
    addToCartButton.removeAttribute("disabled");
  } else {
    addToCartButton.setAttribute("disabled", "true");
  }
}

function addBundleToCart(btn) {
  const bundleItems = document.querySelectorAll(".bundle-2 li");
  const itemsToAdd = [];

  bundleItems.forEach((item) => {
    const id = item.getAttribute("data-id");
    if (id) {
      itemsToAdd.push({
        id: Number(id),
        quantity: 1,
      });
    }
  });

  btn.classList.add("is-loading");

  fetch(theme.routes.cart_add_url + ".js", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ items: itemsToAdd }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Bundle added to cart:", data);
      const cart = document.querySelector("cart-items");
      if (cart) {
        cart.getCart();
      } else {
        window.location.href = theme.routes.cart_url;
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      btn.classList.remove("is-loading");
      btn.removeAttribute("disabled");
    });
}

function moveBundleSelectedData() {
  const bundleSelectedData = document.querySelector(".bundle-selected-data");
  const bundleLeft = document.querySelector(".bundle-left");

  if (window.innerWidth < 767) {
    // Move .bundle-selected-data after .bundle-left
    bundleLeft.appendChild(bundleSelectedData);
  } else {
    // Optionally, move it back to its original place if the screen is wider
    bundleLeft.insertBefore(bundleSelectedData, bundleLeft.nextSibling);
  }
}

// Run on page load
moveBundleSelectedData();

// Run on window resize
window.addEventListener("resize", moveBundleSelectedData);
